import React from 'react';
import PowerplantRowAbstract from './PowerplantRowAbstract';
import { Label, Badge } from 'react-bootstrap';
import { FaLink, FaUnlink, FaTools } from "react-icons/fa";
import { PiTrafficConeLight } from "react-icons/pi";
import Power from './Power';
import Trackers from './Trackers';
import services from './../../lib/Services';
import './powerplants.css';

/**
 * Powerplants' Table for desktop screen.
 * @copyright Optimum Tracker
 * @author wkoffi
 */
class PowerplantRow extends PowerplantRowAbstract
{
	render()
	{
        if(this.props.powerplant.isDisplayed() === false) return (null);
        const status = this.props.powerplant.getStatus();
        const step = this.props.powerplant.getStep();
        const status_icon = (status === 0) ? <FaLink size={20} color="green" title="Connected" /> : ((status === 2) ? <FaLink size={20} color="orange" title="Connected with warnings" /> : <FaUnlink size={20} color="#d9534f" title="Disconnected" />)
        const step_icon = (step === 1) ? <PiTrafficConeLight size={20} color="orange" title="Waiting for commissioning" /> : ((step === 2) ? <FaTools size={20} color="brown" title="Building" /> : '')
        const inactive_class = (status === 1) ? "lost-remote-connection-true-bg " : ""; 
		return (
                <tr>
                    <td className={inactive_class + "text-center"}>
                      {status_icon}
                    </td>
                    { services.getUser().isSuperAdmin() && (<td className={inactive_class + "text-center"}>
                      {step_icon}
                    </td>)}
                    <td className={inactive_class + "text-left"}>
                        <a className="name" href={ services.getMonitoringUrl(this.props.powerplant.getAppId()) } target="_blank" rel="noopener noreferrer"><strong>{this.props.powerplant.getName()}</strong></a>
                    </td>
                    <td className={inactive_class + "text-center"}>
                        <Power powerplant={this.props.powerplant} />
                    </td>
                    <td className={inactive_class + "text-center"}>
                        <Trackers powerplant={this.props.powerplant} />
                    </td>
                    <td className={inactive_class + "text-center"}>
                        { this.props.powerplant.getNbTrackersManual() > 0 && <Badge bsClass="tracker-badge-manual add-margin">{this.props.powerplant.getNbTrackersManual()}</Badge> }
                        { this.props.powerplant.getNbTrackersError() > 0 && <Badge bsClass="tracker-badge-error add-margin">{this.props.powerplant.getNbTrackersError()}</Badge> }
                    </td>
                    <td className={inactive_class + "text-center"}>
                        { this.props.powerplant.getWindSpeed() } km/h { this.state.WindDirectionDisplay && this.props.powerplant.getDirectionAsString() }
                    </td>
                    <td className={inactive_class + "text-center"}>
                        <img src={this.state.OneWindSafety ? "/images/logo/shields3.png" : "/images/logo/shield1.png"}
                            width="15"
                            height="15"
                            className={"location-image-wind-speed windsafety-logo-responsive wind-safety-margin"}
                            title={this.state.OneWindSafety ? "Wind safety ON" : "Wind safety OFF"}
                            alt="Wind safety" />
                    </td>
                    { services.getUser().isSuperAdmin() && (<td className={inactive_class + "text-center"}>
                        { this.props.powerplant.getWarnings().map(line => <Label key={line[1]} bsStyle={line[0] === 2 ? "warning" : "danger"}>{line[1]}</Label>) }
                    </td> )}
                    { services.getUser().isSuperAdmin() && (<td className={inactive_class + "text-center"}>
                        <Badge bsClass={this.props.powerplant.getLastDailyTrackerAvailability() > 95 ? "tracker-badge-ok" : this.props.powerplant.getLastDailyTrackerAvailability() > 80 ? "tracker-badge-manual" : "tracker-badge-error"}>{this.props.powerplant.getLastDailyTrackerAvailability()}</Badge>
                    </td> )}
                    <td className={inactive_class + "text-center"}>
                        <img src="/images/logo/location2.png"
                            width="25"
                            height="25"
                            onClick={() => this.props.setSelectedPowerplantOnMap(this.props.app_id)}
                            className={"location-image mx-auto location-logo-responsive location-img-logo"}
                            title="Zoom on location"
                            alt="location" />
                    </td>
                </tr>
		);
	}
}

PowerplantRow.defaultProps = {
	setSelectedPowerplantOnMap: function(){},
	powerplant: {},
    refreshOnLoad: function(){}
};

export default PowerplantRow;